import React from "react";
import { ShieldCheck, UserCheck, RefreshCw, FileCheck, Repeat, Headphones } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const iconMap = { ShieldCheck, UserCheck, RefreshCw, FileCheck, Repeat, Headphones };

const WhyUs = ({ bg = "white" }) => {
  const { t } = useLang();
  const w = t.whyUs;
  return (
    <section className={bg === "cream" ? "py-20 md:py-24 bg-[#faf6ee]" : "py-20 md:py-24 bg-white"}>
      <div className="max-w-[1200px] mx-auto px-5 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-[#b8893f] font-semibold text-sm tracking-[0.18em] uppercase mb-3">{w.eyebrow}</p>
          <h2 className="font-head font-semibold text-[#12211b] text-3xl md:text-[42px] leading-[1.1]">{w.title}</h2>
          <p className="text-slate-600 mt-4 text-lg">{w.subtitle}</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {w.items.map((it) => {
            const Icon = iconMap[it.icon];
            return (
              <div key={it.title} className="group relative bg-white rounded-2xl border border-[#ece4d3] p-8 hover:shadow-xl hover:border-[#d9b45a]/60 transition-all duration-300">
                <div className="w-12 h-12 rounded-xl bg-teal-50 flex items-center justify-center mb-5 group-hover:bg-teal-700 transition-colors duration-300">
                  <Icon className="w-6 h-6 text-teal-700 group-hover:text-[#d9b45a] transition-colors duration-300" strokeWidth={1.6} />
                </div>
                <h3 className="font-head font-semibold text-[#12211b] text-xl mb-2">{it.title}</h3>
                <p className="text-slate-600 text-[15px] leading-relaxed">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
